import { __awaiter, __generator } from "tslib";
var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["POST"] = "POST";
    Method["PUT"] = "PUT";
    Method["DELETE"] = "DELETE";
})(Method || (Method = {}));
export var API_URL = process.env.REACT_APP_API_URL;
var fetcher = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    var token;
    return __generator(this, function (_a) {
        token = window.sessionStorage.getItem("STREAMY_AUTH_TOKEN");
        if (token) {
            request.headers.append("Authorization", "Bearer " + token);
        }
        return [2 /*return*/, fetch(request).then(function (res) {
                if (!res.ok) {
                    return res.json().then(function (body) {
                        return Promise.reject({
                            status: res.status,
                            ok: false,
                            body: body,
                        });
                    });
                }
                return res.json();
            })];
    });
}); };
export var httpGet = function (url, args) {
    if (args === void 0) { args = { method: Method.GET }; }
    var urlEnding = url.includes("?") ? "" : "/";
    return fetcher(new Request(API_URL + url + urlEnding, args));
};
export var httpPost = function (url, body, args) {
    if (args === void 0) { args = {
        method: Method.POST,
        headers: {
            "Content-Type": "application/json",
        },
        body: body,
    }; }
    return fetcher(new Request(API_URL + url + "/", args));
};
export var httpPut = function (url, body, args) {
    if (args === void 0) { args = {
        method: Method.PUT,
        headers: {
            "Content-Type": "application/json",
        },
        body: body,
    }; }
    return fetcher(new Request(API_URL + url + "/", args));
};
export var httpDelete = function (url, body, args) {
    if (args === void 0) { args = {
        method: Method.DELETE,
        headers: {
            "Content-Type": "application/json",
        },
        body: body,
    }; }
    return fetcher(new Request(API_URL + url + "/", args));
};
//# sourceMappingURL=fetcher.js.map